import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from '../login.component';
import { WelcomeComponent } from '../components/welcome/welcome.component';
import { FirstAccessComponent } from '../components/first-access/first-access.component';
const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: '', component: WelcomeComponent },
  { path: '', component: FirstAccessComponent },
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class LoginRoutingModule {}
